import { Button } from "@material-ui/core";
import React, { ReactElement } from "react";
import { useDispatch } from "react-redux";
import styled from "styled-components/macro";
import { isDesktop, launchExperience } from "../store/selections/selectionsActions";
import Logo from "./Logo";
import { PageViewTracker } from "./PageViewTracker";
import QrCodeDesktop from "./QrCodeDesktop";

const IntroDiv = styled.div`
	flex: 1;
	display: flex;
	align-items: center;
	flex-direction: column;
	overflow-x: hidden;
	text-align: center;
	background-repeat: no-repeat;
	background-image: url(intro7.jpg);
	background-size: cover;
	background-position: center;
	justify-content: space-around;
	
}
`;

const Subtitle = styled.div`
	font-style: italic;
	font-size: 24px;
	position: absolute;
	top: 62%;
	font-weight: 600;
	padding: 15px;
`;

const StartButton = styled(Button)`
	font-size: 24px;
	border-radius: 3px;
	text-transform: none;
	font-weight: normal;
	background: #012169;
	border-radius: 80px;
	height: 105px;
	width: 105px;
	position: absolute;
	top: 72%;
	left: 50%;
	transform: translateX(-50%);
	border: 12px solid rgba(1, 33, 105, 0.4);
	background-clip: padding-box;
`;

const TimeoutWarning = styled.div`
	font-size: 14px;
	position: absolute;
	top: 90%;
	font-weight: 600;
	line-height: 14px;
`;

function Intro(): ReactElement {
	const dispatch = useDispatch();

	const { search } = window.location;

	if (isDesktop && search !== "?mobile") return <QrCodeDesktop />;

	const onStart = () => {
		// TEMP-ER: legal disclaimer for user testing
		//dispatch(setSelectionStep(SelectionStep.Legal));
		// TEMP: Jump straight into experience for now
		dispatch(launchExperience());
		// dispatch(setSelectionStep(SelectionStep.Layout));
	};

	return (
		<IntroDiv>
			<Logo />

			<Subtitle>Visualize your dream kitchen</Subtitle>
			<StartButton color="primary" variant="contained" onClick={onStart}>
				START
			</StartButton>
			<TimeoutWarning>
				App may time out after five minutes of inactivity.
				<br />
				Make sure low power mode is turned off.
			</TimeoutWarning>
			<PageViewTracker pageName={"Intro"} />
		</IntroDiv>
	);
}

export default Intro;
